import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { TwirlDown } from "../../controls/TwirlDown";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { NoveListWidget } from "../../widget/NoveListWidget";
import { BaseDetailView } from "./BaseDetailView";

export class Titles_Related extends BaseDetailView {
  constructor(options) {
    options = options || {};

    options.id = LS2PAC_CONSTANTS.Ids.DetailsPage.relatedContainer;

    options.resultsTemplate = "tmpl/details/titles_related.html";

    super(options);

    this.sections = [];
  }
  destroy() {
    for (var i = 0, len = this.sections.length; i < len; i++) {
      var twirlDown = this.sections[i].twirlDown;
      twirlDown.destroy();
      this.sections[i].twirlDown = null;
    }
    this.sections = [];
  }
  initSyndetics() {
    var target = $(
      "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.libraryThingContainer
    );
    this.destroy();
    target.empty();

    var enrichments = [
      LibraryThing.enums.enrichments.series,
      LibraryThing.enums.enrichments.youMayAlsoLike,
      LibraryThing.enums.enrichments.lists,
      LibraryThing.enums.enrichments.alsoAvailableAs,
      LibraryThing.enums.enrichments.tags,
      LibraryThing.enums.enrichments.rclCoreTitles,
      LibraryThing.enums.enrichments.altmetricBadges,
      LibraryThing.enums.enrichments.alternateSeries,
    ];

    var len = enrichments.length;
    var loaded = 0;
    var metaData = this.currentResource;
    var _this = this;

    for (var i = 0; i < len; i++) {
      var enrichment = enrichments[i];
      var twirlDown = new TwirlDown(enrichment.className, enrichment.label);
      twirlDown.init(
        target,
        (function (twirlDown, enrichment) {
          return function () {
            twirlDown.hide();
            var targetContainer = twirlDown.getContentContainer();
            LibraryThing.addEnrichment(targetContainer, enrichment);
            loaded++;

            if (loaded === len) {
              var selector =
                "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.libraryThingContainer;
              _this.refreshSUMetaData(
                selector,
                metaData,
                function (enrichmentsShown) {
                  _this.onLoadEnrichments(enrichmentsShown);
                }
              );
            }
          };
        })(twirlDown, enrichment)
      );

      this.sections.push({
        enrichment: enrichment,
        twirlDown: twirlDown,
      });
    }
  }
  load(resourceData, index, viewName) {
    NoveListWidget.append(
      this.currentResource,
      $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.novelistContainer)
    );

    if (LibraryThing.hasRelatedTab()) {
      this.initSyndetics();
    }

    this.addEvents();
  }
  onLoadEnrichments(enrichmentsShown) {
    this.sections.forEach(function (section) {
      if (enrichmentsShown.indexOf(section.enrichment.name) !== -1) {
        section.twirlDown.show();
        section.twirlDown.open();
      }
    });
  }
  addEvents() {
    var _this = this;

    $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.novelistContainer).delegate(
      'a[target="_blank"]',
      "click",
      function (event) {
        window.open(event.currentTarget.href);
      }
    );
  }
}
